import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
import "./../../../bindings/bao-tabs";
function UserCustomerDialog(tabPage, parent) {
    var self = this;
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogViewModel.SelectedMandatorId = ko.observable();
    self.DialogViewModel.CustomerId = ko.observable();
    self.DialogViewModel.CustomerName = ko.observable();
    self.DialogViewModel.IsCustomerChangeAllowed = ko.observable();
    self.DialogViewModel.Focus = function () { };
    self.DialogResult = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (self.DialogViewModel.CustomerId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.Show = function (userId, mandatorId, customerId, isCustomerChangeAllowed) {
        tabPage.IsLoading(true);
        self.DialogViewModel.IsCustomerChangeAllowed(isCustomerChangeAllowed);
        self.DialogViewModel.SelectedMandatorId(mandatorId);
        Bao.post("UadmCustom/UserTab/ShowUserCustomerDialog", JSON.stringify({
            sessionTabId: parent.User.TabPage.SessionTabId,
            userId: userId,
            customerId: customerId
        })).then(function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel);
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            self.DialogViewModel.Focus();
            tabPage.IsLoading(false);
        });
    };
}
export default UserCustomerDialog;